import Api from "../api";
const basePath = "/ListTree";
export function get(id) {
    let includeUsers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return Api.get(`${basePath}/items/get?id=${id}&includeUsers=${includeUsers}`);
}
export function getAll(listTreeId) {
    return Api.post(`${basePath}/items/getAll?ListTreeId=${listTreeId}`);
}
export function getAllLazy(request) {
    return Api.post(`${basePath}/items/getAllLazy`, request);
}
export function originOfInformation(listTreeId, formId) {
    let strParams = `?listTreeId=${listTreeId}`;
    if (formId) {
        strParams += `&formId=${formId}`;
    }
    return Api.get(`${basePath}/items/origin-of-information${strParams}`);
}
export function importFile(file, listTreeId) {
    const formData = new FormData();
    formData.append("file", file);
    return Api.post(`${basePath}/items/import-from-file?listTreeId=${listTreeId}`, formData);
}
export function register(params) {
    return Api.post(`${basePath}/items/register`, params);
}
export function remove(id) {
    return Api.post(`/ListTree/items/delete?id=${id}`);
}
export function update(params) {
    return Api.post(`${basePath}/items/update`, params);
}
